import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { filter } from 'rxjs/operators';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectOfferDO } from '../../../../../../system/system-dtos';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';

interface OfferItem {
  id: number;
  offer: SelectOfferDO;
  fieldConfig: FieldConfigDTO;
  fields: FieldConfigDTO[];
  data: any;
}
@Component({
  selector: 'app-form-field-offer',
  templateUrl: './offer-form-field.component.html',
  standalone: false,
})
export class OfferFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  offers: SelectOfferDO[] = [];

  offerData: any;

  selected: SelectOfferDO;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  offerId: any;

  offerList: OfferItem[] = [];

  constructor(
    private blastService: BlastV2Service,
    private entityGroupService: EntityGroupDetailsService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.blastService
      .getCollectionObservable('promotionoffer')
      .pipe(filter((d) => !!d))
      .subscribe((list) => {
        this.offers = list.sort((a: SelectOfferDO, b: SelectOfferDO) => {
          if (a.displayOrder > b.displayOrder) {
            return 1;
          }
          if (a.displayOrder < b.displayOrder) {
            return -1;
          }
          return 0;
        });

        if (this.data !== undefined) {
          this.onOfferChange(
            this.data.offer ? this.data.offer : this.data,
            new MatOptionSelectionChange(null, true),
            this.rowData?.offer ? this.rowData?.offer?.offerData : this.rowData?.offerData
          );
        }
      });

    // this.onOfferChange(this.data, new MatOptionSelectionChange(null, true), this.rowData.overall ? this.rowData.overall.offerData : this.rowData.offerData);
  }

  // onOfferChange(offer: SelectOfferDO, $event: MatOptionSelectionChange, item:OfferItem, offerData:any) {
  onOfferChange(offer: SelectOfferDO, $event: MatOptionSelectionChange, offerData: any) {
    if (!$event.isUserInput || (this.selected && offer.id === this.selected.id)) {
      return;
    }
    this.selected = offer;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.offerId = offer ? offer.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        row.columns.forEach((column) => {
          column.fields.forEach((f) => {
            this.fields.push(f);
          });
        });
      });
    }
    if (offerData !== undefined && !(Object.keys(offerData).length === 0 && offerData.constructor === Object)) {
      this.offerData = offerData;
    } else {
      this.offerData = offer.dataTemplate;
    }

    this.selectedFieldConfig = {
      name: 'offerData',
      label: 'Offer:',
      type: DataType.offer,
      strippedRows: true,
    } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;

    // gbw - start
    this.offerList.push({
      offer,
      fieldConfig: this.selectedFieldConfig,
      fields: this.fields,
    } as OfferItem);
    this.entityGroupService.isotopeLayout.next();
  }

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnDestroy() {}

  addRow() {
    this.offers;
    const fieldConfig = { name: 'offerData', label: 'Offer:', type: DataType.offer } as FieldConfigDTO;
    fieldConfig.innerFields = this.fields;
    this.offerList.push({
      offer: this.offers[0],
      fieldConfig,
      fields: this.fields,
    } as OfferItem);
  }

  deleteRow(item: OfferItem) {
    this.offerList = this.remove(this.offerList, 'id', item.id);
  }

  remove(array: OfferItem[], key: string, value: any) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0 ? [...array.slice(0, index), ...array.slice(index + 1)] : array;
  }
}
